import React, { useState } from 'react';
//import dadesbancaries from '../data/dadesbancaries.json'
//import assignatures from '../data/assignatures.json'
import llista_bonificacions from '../../../data/llista_bonificacions.json'
import config from '../../../config';
import { textPlaAHtml, htmlDesat } from './formatText'
//import llistaExemptesPagament from '../../../data/llista_exemptes_pagament.cavallbernat.json'
//import llistaExemptesPagamentAmbLlibres from '../../../data/llista_exemptes_pagament_amb_llibres.cavallbernat.json'

// abans es carregaven amb require() en temps de build; ara arriben en viu des de l'API
// (amb el mateix fallback als JSON estàtics al servidor), injectades per studies.*.js
// via setCataleg() un cop resolt el fetch
let dadesbancaries = {}
let assignatures = {}

export function setCataleg(novesAssignatures, novesDadesBancaries) {
  assignatures = novesAssignatures ?? assignatures
  dadesbancaries = novesDadesBancaries ?? dadesbancaries
}

let materialPrimerTermini = 0;
let materialSegonTermini = 0;


const exemptPagament = (iddocument,becat) => {
  if( becat === "B") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagament.filter( id => id === iddocument ).length > 0
  return false
}

const exemptPagamentAmbLlibres = (iddocument,becat) => {
  if( becat === "L") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagamentAmbLlibres.filter( id => id === iddocument ).length > 0
  return false
}


export function calculQuota(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre ) {

let quota = {
             matricula: 0,
             asseguranca: 0,
             material: 0,
             formacio: 0,
             bonificacio: 0,
             moduls: 0,
             extres: { total: 0 },
             total: 0,
             dadesbancaries: dadesbancaries }


             
             
  /* controls que impedeixen que es calcul la quota sense tenir les dades corresponents necessaries per al càlcul */
  if (dataNaixement === undefined) return quota
  if (curs === undefined) return quota
  if (curs?.id === undefined) return quota
  if (!assignatures[curs.id]) return quota // catàleg encara no ha arribat de l'API




  let temps = new Date()
  temps.setFullYear(new Date().getFullYear() - 28)
  quota.menor28 = dataNaixement.getTime() >= temps.getTime() ? true : false




  // busquem nivell maxim de assignatura (només cal que en tinguin una de 2n per ser matricula de 2n curs)
  let nivellMax = 0

  const llistaAssignatures = assignatures[curs.id]
  llistaAssignatures.map((ll) => {
    ll.subjects.map((s) => {

      if (assignaturesTriades.includes(s.id)) {
        if (s.level > nivellMax) {
          nivellMax = s.level
        }
      }
    }
    )
  })

  setNivellMax(nivellMax)





  /****************************************************************************
   * 
   *   int preu: quotaAsseguranca (bool menor28 )
   * 
  *****************************************************************************/
  const quotaAsseguranca = (menor28) => {

    if (menor28) return 1.15
      
    return 0
  }



  const quotaMaterialSimple = (curs) => {

    if (curs.material === undefined ) return 0

    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
            return mats.push({...m,checked: m.check })
      })

      setMaterials(mats)
    }


    let totalMaterials =  0

      materials.map((m) => 
      { 

          if(m.checked) totalMaterials += m.preu
            
      })

      
    return totalMaterials
  }



  /****************************************************************************
   * 
   *  totalMaterials = quotaMaterialComplexa (curs, matriculaParcial, nouAlumne)
   * 
   * 
  *****************************************************************************/
  // La Complexa te en compte preu per assignatura  de material i sortides
  const quotaMaterialComplexa = (curs, matriculaParcial, nouAlumne ) => {

    if (curs.material === undefined ) return 0

    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
            return mats.push({...m,checked: m.check })
      })

      setMaterials(mats)
    }


    let totalMaterials =  0

      //variable global aquí reinicialitzem al començar el càlcul 
      materialPrimerTermini =  0 
      materialSegonTermini =  0 

      materials.map((m) => 
      { 

          //console.log("mP",matriculaParcial)

         // a les matricules parcials no paguen cap d'aquests conceptes, es paga per mòdul triat
          if(matriculaParcial)
          {

              // potser s'hauria de calcular fer pagaments parcials amb els extra

            if(m.id.startsWith("material"))
            {
              return
            }
            else if(m.id.startsWith("menus"))
            {
              return
            }
            else if(m.id.startsWith("sortides"))
            {
              return
            }
            else if(m.id.startsWith("armariet"))
            {
              return
            }

          }


        //només paguen material extra de primer els nous alumnes
        if (curs.id === "CFPMIA60") {

          if (m.id === "materialextra1" && !nouAlumne) {
            return
          }

        } else if (curs.id === "CFPSHTF0") {

          if (m.id === "materialextra1" && !nouAlumne) {
            return
          }

        }


        const sumaMaterial = (nivellMax,m) => {

              if (m.id.endsWith("1") && nivellMax === 1) { if (m.checked) return m.preu }
              if (m.id.endsWith("2") && nivellMax === 2) { if (m.checked) return m.preu }

              if (!m.id.endsWith("1") && !m.id.endsWith("2")) { if (m.checked) return m.preu }

              return 0
        }



        
        
        // per calcular primer termini
        switch (curs.id) {

          // menús i assegurança
          case "CFPMIA60":
          case "CFPMHT10":
          case "CFPMHT30":
            if (m.id.startsWith("menus"))
              materialPrimerTermini += sumaMaterial(nivellMax, m)
            break


          // ara només matricula i armariet
          case "CFPMCM20":
            if (m.id.startsWith("material")
              ||
              m.id.startsWith("armariet")
            )
              materialPrimerTermini += sumaMaterial(nivellMax, m)
            break

          case "CFPSHTD0": // Tres terminis!
          case "CFPSHTE0":

            if (m.id.startsWith("menus"))
            {

            console.log(" CFPSHTD0 ", m.id,"++",m.preu)
              materialSegonTermini += sumaMaterial(nivellMax, m)
            }

            break




          default:
            if (!m.id.startsWith("sortides") && !m.id.startsWith("menus")) materialPrimerTermini += sumaMaterial(nivellMax, m)
        }


        // suma al material total
        totalMaterials += sumaMaterial(nivellMax, m)
      })




      
    return totalMaterials
  }





  const quotaBonificacio = (matricula,bonificacio) => {

    const bon = llista_bonificacions.filter(b => b.id === bonificacio ).pop()

    if (!bon) return 0

    switch (bon.descompte) {
      case '50%': return matricula / 2;
      case '100%': return matricula;
      default: return 0;
    }
  }


const quotaCFGM = (quota, assignaturesTriades, nouAlumne ) => {

//const preuUF = 25
const preuFCT = 10

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {

    const llistaPreus = []
    const llistaExtres = []
    const llistaAssignaturesZero= []
    const llistaAssignaturesTriadesZero = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesTriadesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaAssignaturesTriadesSegon = []
    const llistaBlocsZero = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu
          llistaExtres[assignatura.id] = assignatura.extres ?? {}

          if (assignatura.level === 0) {

            llistaAssignaturesZero.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { 
                llistaAssignaturesTriadesZero.push(assignatura)
                llistaBlocsZero[bloc.id] = llistaBlocsZero[bloc.id] == undefined ? 1 : llistaBlocsZero[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { 
                llistaAssignaturesTriadesPrimer.push(assignatura)
                llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { 
                llistaAssignaturesTriadesSegon.push(assignatura)
                llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )


    matricula_parcial_1r = true;
    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
    }


    matricula_parcial_2n = true;
    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
    }



    /* CALCUL MATRICULA PARCIAL PREU PER ASSIGNATURA */

    quota.matricula = 0
    quota.extres = { total: 0}

      //console.log("TEST0",matricula_parcial_0," && ",matricula_parcial_1r," && ", matricula_parcial_2n)

      /* les dues en parcial */
    if (matricula_parcial_1r && matricula_parcial_2n) {

    llistaAssignaturesTriadesZero.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
    llistaAssignaturesTriadesZero.forEach((ass) => {
        Object.keys(llistaExtres[ass.id]).forEach((extra) => {
          const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
          quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
          quota.extres.total += cost_extra
        })
      })


      //console.log("TEST0.0",matricula_parcial_1r," && ", matricula_parcial_2n)

    llistaAssignaturesTriadesPrimer.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
    llistaAssignaturesTriadesPrimer.forEach((ass) => {
        Object.keys(llistaExtres[ass.id]).forEach((extra) => {
          const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
          quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
          quota.extres.total += cost_extra
        })
      })

    llistaAssignaturesTriadesSegon.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
    llistaAssignaturesTriadesSegon.map((ass) => { 
        Object.keys(llistaExtres[ass.id]).forEach((extra) => {
          const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
          quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
          quota.extres.total += cost_extra
        })
    })

    }
    else if (matricula_parcial_1r || matricula_parcial_2n)
    {
      //console.log("TEST0.1",matricula_parcial_1r," && ", matricula_parcial_2n)

      // preu Zero
      if (matricula_parcial_0) {
        llistaAssignaturesTriadesZero.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
        llistaAssignaturesTriadesZero.forEach((ass) => {
          Object.keys(llistaExtres[ass.id]).forEach((extra) => {
            const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
            quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
            quota.extres.total += cost_extra
          })
        })
      }

          // preu 1r
      if (matricula_parcial_1r) {
        //console.log("TEST1",matricula_parcial_1r,quota.matricula,llistaAssignaturesTriadesPrimer);
        llistaAssignaturesTriadesPrimer.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
        llistaAssignaturesTriadesPrimer.forEach((ass) => {
          Object.keys(llistaExtres[ass.id]).forEach((extra) => {
            const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
            quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
            quota.extres.total += cost_extra
          })
        })
      }

    // preu 2n
      if (matricula_parcial_2n) {
        //console.log("TEST2",matricula_parcial_2n,quota.matricula,llistaBlocsSegon);
        llistaAssignaturesTriadesSegon.map((ass) => { quota.matricula += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
        llistaAssignaturesTriadesSegon.map((ass) => {
          Object.keys(llistaExtres[ass.id]).forEach((extra) => {
            const cost_extra = llistaExtres[ass.id][extra] ? llistaExtres[ass.id][extra] : 0
            quota.extres[extra] = (quota.extres[extra] || 0) + cost_extra
            quota.extres.total += cost_extra
          })
        })
      }


    }

   // assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.matricula += preuUF })
   //quota.matricula += ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    //DEBUG 
    //console.log("CALCUL", quota.matricula,quota.material,quota.extres)

    /* moduls */
    quota.moduls = 0

  }

  quota.total += quota.moduls + quota.matricula + quota.extres.total

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n, nouAlumne)
  }
  quota.total += quota.material

  //console.log("QUOTA",quota)

  // total
  return quota;
}


const quotaCFGS = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2, nouAlumne) => {

  const preuNEE = 0
  const preuFCT = 25
  const preuFCTModul = 10
  const preuMatricula = 360
  const preuUF = 65

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    //quota.moduls = preuFCTModul

  } else {

    const llistaPreus= []
    const llistaExtres= []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesTriadesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaAssignaturesTriadesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []





    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

            llistaPreus[assignatura.id] = assignatura.preu
            llistaExtres[assignatura.id] = assignatura.extres ?? {}

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { 
              llistaAssignaturesTriadesPrimer.push(assignatura)
              llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { 
              llistaAssignaturesTriadesSegon.push(assignatura)
              llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    matricula_parcial_1r = true;
    let matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    let matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)


    /* moduls */
    quota.moduls = 0
    quota.extres = { total: 0 }


    const sumaExtresQuota = (ass,quota) => {

      Object.keys(llistaExtres[ass]).forEach((extra) => {
        const cost_extra = llistaExtres[ass]?.[extra] ? llistaExtres[ass][extra] : 0
        quota.extres[extra] = (quota.extres[extra] ?? 0) + cost_extra
        quota.extres.total += cost_extra
      })

    }

    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass) ).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)




    // CALCUL MATERIAL ASSIGNATURES TRIADES
    assignaturesTriades.filter((ass) => { quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 })

    assignaturesTriades.filter((ass) => sumaExtresQuota(ass,quota) )

    }
    else {

    if (matricula_parcial_1r || matricula_parcial_2n)
    {
      //console.log("TEST0.1",matricula_parcial_1r," && ", matricula_parcial_2n)

      // preu 1r
      if (matricula_parcial_1r) {
        //console.log("TEST1",matricula_parcial_1r,quota.matricula,llistaAssignaturesTriadesPrimer);
        llistaAssignaturesTriadesPrimer.map((ass) => { quota.moduls += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
        llistaAssignaturesTriadesPrimer.map((ass) => sumaExtresQuota(ass.id,quota) )
          
        //console.log("TEST1.1",matricula_parcial_1r,quota.matricula);
      }

      // preu 2n
      if (matricula_parcial_2n) {
        //console.log("TEST2",matricula_parcial_2n,quota.matricula,llistaBlocsSegon);
        llistaAssignaturesTriadesSegon.map((ass) => { quota.moduls += llistaPreus[ass.id] ? llistaPreus[ass.id] : 0 })
        llistaAssignaturesTriadesSegon.map((ass) => sumaExtresQuota(ass.id,quota) )
          
        //console.log("TEST2.1",matricula_parcial_2n,quota.matricula);
      }

    }

      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls + quota.extres.total )


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio

    quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n, nouAlumne)

    quota.total += quota.material
  }

  return quota;
}


// iniciem a 'null'
let formacio = undefined
let llistaAssignaturesZero =  []
let llistaAssignaturesPrimer =  []
let llistaAssignaturesSegon =  []
let matricula_parcial_0 = true;
let matricula_parcial_1r = true;
let matricula_parcial_2n = true;
//let matricula_parcial_1r_count = 0;
//let matricula_parcial_2n_count = 0;

quota.asseguranca = 0;
quota.material = 0;
quota.total = 0;

switch(curs.id)
{
     // ESO 1 i 2
     case "ESOLOE01": 
     case "ESOLOE02": 
     // ESO 3 i 4
     case "ESOLOE03": 
     case "ESOLOE04": 
                        // assegurança
                        //quota.asseguranca = quotaAsseguranca(quota.menor28)
                        quota.asseguranca = 0
                        quota.total += quota.asseguranca

                        quota.matricula = 0
                        quota.total += quota.matricula

                        // material
                        quota.material = quotaMaterialSimple(curs)
                        quota.total += quota.material

                        // total
                        return quota;

     // BATX 1 i 2
    case "BATXLOE2000": 
    case "BATXLOE3000": 
    case "BATXLOE20001": 
    case "BATXLOE20002": 
    case "BATXLOE30001": 
    case "BATXLOE30002": 
                        // assegurança
                        //quota.asseguranca = quotaAsseguranca(quota.menor28)
                        quota.asseguranca = 0
                        quota.total += quota.asseguranca

                        quota.matricula = 0
                        quota.total += quota.matricula

                        // material
                        quota.material = quotaMaterialSimple(curs)
                        quota.total += quota.material
                        // total
                        return quota;

  /*
  { CFPMCM20 CFGM Comercialització de productes alimentaris
  { CFPMIA60 CFGM Forneria, pastisseria i confiteria
  { CFPMHT10 CFGM Cuina i gastronomia
  { CFPMHT30 CFGM Serveis en restauració

  { CFPSHTA0 CFGS Agències de viatges i gestió d'esdeveniments
  { CFPSHTF0 CFGS Guia, informació i assistència turístiques/Agències de viatges i gestió d'esdeveniments
  { CFPSHTE0 CFGS Direcció de serveis en restauració
  { CFPSHTD0 CFGS Direcció de cuina
  */

    // MITJOS

     //CFGM Comercialització de productes alimentaris
  //case "CFPMCM20A": 
  case "CFPMCM20": 
    return quotaCFGM(quota, assignaturesTriades, nouAlumne)

  // CFGM Forneria, pastisseria i confiteria
  //case "CFPMIA60A": 
  case "CFPMIA60": 
    return quotaCFGM(quota, assignaturesTriades, nouAlumne)

  // CFGM Cuina i gastronomia
  //case "CFPMHT10A":
  case "CFPMHT10":
    return quotaCFGM(quota, assignaturesTriades, nouAlumne)

  // CFGM Serveis en restauració
  //case "CFPMHT30A":
  case "CFPMHT30":
    return quotaCFGM(quota, assignaturesTriades, nouAlumne )

  // CFGS NOMÉS FCT
  case "CFGMFCT":
    return quotaCFGM(quota, assignaturesTriades, nouAlumne)


    // SUPERIOR

  // CFPSHTA0 CFGS Agències de viatges i gestió d'esdeveniments
  case "CFPSHTA0":
  case "CFPSHTA0N":
    return quotaCFGS(quota, assignaturesTriades, 0, 12, 12, nouAlumne)

  // CFGS Guia, informació i assistència turístiques/Agències de viatges i gestió d'esdeveniments
  case "CFPSHTF0":
  case "CFPSHTF0N":
    return quotaCFGS(quota, assignaturesTriades, 0, 19, 19, nouAlumne)

  // CFGS Direcció de serveis en restauració
  case "CFPSHTE0":
  case "CFPSHTE0N":
    return quotaCFGS(quota, assignaturesTriades, 0, 26, 26, nouAlumne)

  // CFGS Direcció de cuina
  case "CFPSHTD0":
  case "CFPSHTD0N":
    return quotaCFGS(quota, assignaturesTriades, 0, 12, 12, nouAlumne)

  // CFGS NOMÉS FCT
  case "CFGSFCT":
    return quotaCFGS(quota, assignaturesTriades, 0, 0, 0, nouAlumne)


  default: return quota;
      
}

}


/*****************************************
 * 
 * MostraQuota
 * 
 * 
 * 
 */

export const MostraQuota = (props)  => {

let quota = props.quota

const terminis = props.curs?.textTerminis ?? config.textTerminis
const text1Termini = terminis[0]
const text2Termini = terminis[1]
const text3Termini = terminis[2]

const [bonificacio, setBonificacio] = useState([]);

// condicions 0: 1 termini
// condicions 1: 2 terminis
// condicions 2: 3 terminis
const mostraBotoTerminisCriteri = ( 
           !config.dosTerminisAmagaBoto && // forçat a amagar botó?
          ( (props.curs.condicions === 1 || props.curs.condicions === 2) && config.dosTerminisEnabled ) && // tipus de condicions permeten +1 pagament
          ( (quota.bonificacio < quota.matricula || quota.bonificacio === 0)  && // bonificats < 100%
           quota.total >= 100 )) // més de 100€ a pagar



const canviaPreuMaterial = (id,preu) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.preu = preu )

  props.setMaterials(mat)

}

const canviaTxtMaterial = (id,txt) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.txt = txt )

  props.setMaterials(mat)

}


const handleChangeMaterial = (t) => {

let mat = [...props.materials]

  mat.filter(item => item.id === t).map( (i) => i.checked = !i.checked )

  props.setMaterials(mat)

}

const isMaterialChecked = (id) => {

let mat = props.materials.filter(item => item.id === id).pop()

if(mat === undefined ) return false
return mat.checked
}


const handleChangeBonificacions = (t) => {
  props.setBonificacions(t)
  setBonificacio(t)
}

const handleChangeTerminis = (t) => {
  props.setDosTerminis(t)
}


// calcul quotes  / terminis
//console.log("2T", props.dosTerminis);

quota.termini1 = undefined
quota.termini2 = undefined
quota.termini3 = undefined

/* DOS TERMINIS */
if( props.curs.condicions === 1 && config.dosTerminisEnabled )  
{

  if (props.dosTerminis) {

    if (quota.total >= 100) // minim 100 euros per 
    {

      switch (props.cicle) {

        // Taxes 1r i resta 2n
        case "CFGS":
          //quota.termini1 = quota.matricula - quota.bonificacio + materialPrimerTermini + quota.asseguranca + quota.moduls
          quota.termini1 = quota.matricula - quota.bonificacio + quota.asseguranca
          quota.termini2 = quota.total - quota.termini1
          //console.log("termini1",quota.termini1,"=", quota.matricula," -", quota.bonificacio," + ", materialPrimerTermini," +", quota.asseguranca)

          break

        case "CFGM":
              //quota.termini1 = materialPrimerTermini + quota.asseguranca + quota.sortides + quota.moduls
              quota.termini1 = materialPrimerTermini + quota.asseguranca + quota.matricula

              if (quota.termini1 === 0) { quota.termini1 = quota.total / 2 } // si alguna cosa va malmanent en el calcul de materials fem minim 50%-50%

              quota.termini2 = quota.total - quota.termini1
              break

        default:
          quota.termini1 = undefined
          quota.termini2 = undefined
      }

    } else {
      quota.termini1 = undefined
      quota.termini2 = undefined
    }

  }

/* TRES TERMINIS */
} else if( props.curs.condicions === 2 && config.dosTerminisEnabled )  { 

  
  if (props.dosTerminis) {
    
    if (quota.total >= 100) // minim 100 euros per 
    {
      
      switch (props.cicle) {
        
        // Taxes 1r i resta 2n
        case "CFGS":
          //quota.termini1 = quota.matricula - quota.bonificacio + quota.asseguranca
          quota.termini1 = quota.matricula - quota.bonificacio + materialPrimerTermini + quota.asseguranca + quota.moduls
          quota.termini2 = materialSegonTermini
          quota.termini3 = quota.total - quota.termini1 - quota.termini2

          /* per si hi hagués algun cas que no hi ha material de 2n termini, millor passar-ho de nou a 2 */
          if(quota.termini3 > 0 && quota.termini2 === 0) {
          quota.termini2 = quota.termini3 
          quota.termini3 = undefined
          }

          break

          /*
        case "CFGM":
              //quota.termini1 = materialPrimerTermini + quota.asseguranca + quota.sortides + quota.moduls
              quota.termini1 = materialPrimerTermini + quota.asseguranca + quota.matricula

              if (quota.termini1 === 0) { quota.termini1 = quota.total / 2 } // si alguna cosa va malmanent en el calcul de materials fem minim 50%-50%

              quota.termini2 = quota.total - quota.termini1
              break
              */

        default:
          quota.termini1 = undefined
          quota.termini2 = undefined
          quota.termini3 = undefined
      }

    } else {
      quota.termini1 = undefined
      quota.termini2 = undefined
      quota.termini3 = undefined
    }

  }
}



let enguany = new Date().getFullYear()
let anyVinent = enguany + 1
anyVinent = anyVinent.toString().slice(-2)

  return (
    <div className="col col-12">

      <div className="row">
        <div className="t-Form-labelContainer">
          <label className="t-Form-label"> Quota de pagament del curs escolar {enguany}/{anyVinent}</label>
        </div>
      </div>

      <div className="row">
      <div className="col quota">


        <div className="quotaTitol">Curs: {props.curs.value} ({props.curs.id})</div>

        <div className="quotaDadesBancaries">

        { quota.total >0 && ( quota.dadesbancaries.IBAN && ( <>

          <div><span className="quotaNomCamp">Entitat bancària:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.entitat)} /></div>

          <div> <span className="quotaNomCamp">nº IBAN:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.IBAN)} /></div>

          </>) ) }

          <div className="quotaDadesPagamentCalendari"><span className="quotaNomCamp">Condicions:</span> <span dangerouslySetInnerHTML={htmlDesat(quota.dadesbancaries.condicions[props.curs.condicions])} /></div>

        </div>

        <label> Conceptes </label>

        <table className="quota table">
          <tbody>

              { ( !props.curs.id.startsWith("ESO") && !props.curs.id.startsWith("BATX") ) &&
                (<>
                  <tr>
                    <th className="quotaNomCamp" colspan="2">Assegurança escolar obligatòria: </th>
                  </tr>

                  <tr>
                    {quota.menor28 && (<td className="col">Alumnat menor de 28 anys</td>)}
                    {!quota.menor28 && (<td className="col">Alumnat de 28 anys i major</td>)}
                    <td>{(quota.asseguranca).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>
                  </tr>
                </>) }


          {/* preu "material" per les matrícules parcials  */}
          { quota.moduls > 0 && (
          <tr>
            <td>Material mòduls matriculats:</td>
            <td>{(quota.moduls).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          {/* preu "taxes/material" per les matrícules parcials  */}
          { quota.matricula > 0 && (
          <tr>
            <td>{ props.curs.id.startsWith("CFPM") ? "Material curs:" : "Taxes:" }</td>
            <td>{(quota.matricula).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          {/* preu sortides per les matrícules parcials */}
          { quota.sortides > 0 && (
          <tr>
            <td>Sortides:</td>
            <td>{(quota.sortides).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          {/* preu extres per les matrícules parcials */}
          {quota.extres.total > 0 &&

            (Object.keys(quota.extres).map((extra) => {

              return extra === "total" ?
                (<></>)
                :
                (<tr>
                  <td className="ucfirst">{extra}:</td>
                  <td>{(quota.extres[extra]).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>
                </tr>)
            })

            )
          }


          {props.curs?.bonificacions === true && (<tr><th colspan="2" className="quotaNomCamp">Bonificacions / Exempcions:</th></tr>)}


          {props.curs?.bonificacions === true && (
                <tr>
                  <td>
                    <select id="bonificacions" name="bonificacions" defaultValue={bonificacio} onChange={(e) => handleChangeBonificacions(e.target.value)}>
                      {llista_bonificacions.map((m, k) =>
                        <option key={k} id={m.id} name={m.id} value={m.id}>{m.valor} ({m.descompte})</option>
                      )}
                    </select>
                  </td>
                  <td>
                    {quota.bonificacio >0 && "-"+(quota.bonificacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })+ "€" }
                  </td>
                </tr>
          )}

          { quota.formacio > 0 && (<tr><td className="quotaNomCamp">Despeses de formació:</td><td>{(quota.formacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>)}

          { /*quota.material > 0 && (<tr><td className="quotaNomCamp">Material del cicle:</td><td>{(quota.material).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>) */}


          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?

            (
              <>
              <tr><th colspan="2" className="quotaNomCamp">Preu curs escolar:</th></tr>
              </>

            ) 
            : 
            (
              <>
              {/* Si l'import del material és 0 no cal mostrar */}
              {!props.curs.material && (<tr><td className="quotaNomCamp"></td> </tr>)}
              {props.curs.material && (<tr><th colspan="2" className="quotaNomCamp">Material específic del cicle:</th></tr>)}
              </>
            )}

          {props.curs.material && props.curs.material.map((m, p) => {

            let disabled = false

            if ( props.assignatures?.length === 1 && /^FCT/.test(props.assignatures[0]) ) { // si només fan FCT no hi ha mai material
                return false
            } 
            else
            {

              let preu_material = 0;

              // MATERIALS
              switch (props.curs.id) 
              {
                // ESO 1, 2, 3 i 4
                case "ESOLOE01": 
                case "ESOLOE02": 
                case "ESOLOE03": 
                case "ESOLOE04": 
                // BATX 1 i 2
                case "BATXLOE2000": 
                case "BATXLOE3000": 
                case "BATXLOE20001": 
                case "BATXLOE20002": 
                case "BATXLOE30001": 
                case "BATXLOE30002": 
                  if( m.id === "material")
                  {
                      //NESE B
                      if(exemptPagament(props.iddocumen,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat))
                      { 
                        if(m.preu != 0)
                        {
                          m.preu = 0
                          canviaPreuMaterial(m.id, 0)
                        }
                      }


                        disabled = true; 
                        break; 
                  }

                  if( m.id === "ampa")
                  {
                        disabled = false; 
                        break; 
                  }

              break;

              /* CICLES MITJOS */

              //CFGM Forneria, pastisseria i confiteria 
                //case "CFPMIA60A":
                case "CFPMIA60":

              //CFGS Guia, informació i assistència turístiques/Agències de viatges i gestió d'esdeveniments 
                case "CFPSHTF0N":
                case "CFPSHTF0":

                    //if(props.curs.id === "CFPMIA60") //{ //}
                          //només paguen material extra de primer els nous alumnes
                          if (m.id === "materialextra1" && !props.nouAlumne )
                          {
                            return
                          }

              //CFGS Guia, informació i assistència turístiques/Agències de viatges i gestió d'esdeveniments 
                case "CFPSHTF0N":
                case "CFPSHTF0":


              //CFGM Comercialització de productes alimentaris 
                //case "CFPMCM20A":
                case "CFPMCM20":

              //CFGM Cuina i gastronomia 
                //case "CFPMHT10A":
                case "CFPMHT10":

              //CFGM Serveis en restauració 
                //case "CFPMHT30A":
                case "CFPMHT30":

              //CFGS Agències de viatges i gestió d'esdeveniments 
                case "CFPSHTA0N":
                case "CFPSHTA0":


              //CFGS Direcció de serveis en restauració 
                case "CFPSHTE0N":
                case "CFPSHTE0":

              //CFGS Direcció de cuina 
                case "CFPSHTD0N":
                case "CFPSHTD0":

                //CFGM Gestió Administrativa
                case "CFPMAG10N": 
                case "CFPMAG10": 

                // CFGM de Cures auxiliars d’infermeria
                case "CFPM1601N": 
                case "CFPM1601": 

                  const llistaAssignaturesZero = []
                  const llistaAssignaturesPrimer = []
                  const llistaAssignaturesSegon = []

                  assignatures[props.curs.id].map((bloc) => {
                    bloc.subjects.map(
                      (assignatura) => {
                        if (assignatura.level === 0) { llistaAssignaturesZero.push(assignatura.id) }
                        if (assignatura.level === 1) { llistaAssignaturesPrimer.push(assignatura.id) }
                        if (assignatura.level === 2) { llistaAssignaturesSegon.push(assignatura.id) }
                      }
                    )
                  }
                  )


                  let matricula_parcial_1r = true;
                  if (llistaAssignaturesPrimer.length > 0) {
                    let copiaAssignatures1r = [...llistaAssignaturesPrimer]

                    matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }

                  let matricula_parcial_2n = true;
                  if (llistaAssignaturesSegon.length > 0) {
                    let copiaAssignatures2n = [...llistaAssignaturesSegon]

                    matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }




                  // BEGIN - TRACTAMENT CURSOS PARCIALS 
                  if (matricula_parcial_1r && matricula_parcial_2n) 
                  {
                    // Material a ignorar en cursos parcials - també cal posar-los al calculQuota
                    if (m.id.startsWith("material")
                      || m.id.startsWith("sortides")
                      || m.id.startsWith("armariet")
                      || m.id.startsWith("menus")
                    ) {
                      return (<></>)
                    }
                  }

                    
                  // END - TRACTAMENT CURSOS PARCIALS 




                  // Material curs
                  if(m.id === "material" || m.id === "menus")
                    {
                    // sempre obligatori - només canvia preu si no és necessari pel curs
                    disabled = true;
                    break;
                  }



              //material de 1r
                  if (m.id.endsWith("1")) {

                    //console.log("cosa de primer 1",m)

                    if (props.nivellMax === 2) {

                      // si estem a 2n no mostrem el de primer
                      if (m.checked) {
                        m.checked = false
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                        props.setMaterials(mat)
                      }
                      return

                    } else {

                      if (!m.checked) {
                        m.checked = true
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                        props.setMaterials(mat)
                      }
                        disabled = true; 
                        break

                    }
                  }else if (m.id.endsWith("2")) { //material de 2n

                    //console.log("cosa de segon 2",m)

                    if (props.nivellMax === 2) {

                      if (!m.checked) {
                        m.checked = true
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                        props.setMaterials(mat)
                      }
                        disabled = true; 
                        break

                    } else {

                      // si no estem a 2n no mostrem el de primer
                      if (m.checked) {
                        m.checked = false
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                        props.setMaterials(mat)
                      }
                      return

                    }
                  }


            if(m.id=== "mocadorcorbata")
            {
                //console.log("MOCADOR_CORBATA",m.checked,props.materials);

              // per mantenir el preu original en el cas que s'hagi de canviar a 0 i posteriorment restaurar
              m.preuMocadorCorbataOrig = m.preuMocadorCorbataOrig ?? m.preu
              m.txtMocadorCorbataOrig = m.txtMocadorCorbataOrig ?? m.txt

              //if (!matricula_parcial_1r || !matricula_parcial_2n) 
              if(props.nivellMax === 1)
              {
                  //  si fan 1r l'han de demanar 
                  if(!m.checked)
                    {
                    m.checked = true
                    let mat = [...props.materials]
                    mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                    props.setMaterials(mat)
                  }

                   m.txt = m.txtMocadorCorbataOrig

                    disabled = true
                    break;
              }
              else
              {

                // si fan matricula parcial, pels nous és obligatori , els altres poden triar

                if(props.nouAlumne) 
                { 

                  if (!m.checked) {
                    m.checked = true
                    let mat = [...props.materials]
                    mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                    props.setMaterials(mat)
                  }

                   m.txt = m.txtMocadorCorbataOrig

                    disabled = true 
                    break;
                }
                else
                {
                  if (m.checked) {
                    m.checked = false
                    let mat = [...props.materials]
                    mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                    props.setMaterials(mat)
                  }

                }

                
              }

                  m.txt = m.txtMocadorCorbataOrig + " (opcional per repetidors)"
              
              disabled = false
              break; 
            }


            disabled = true; 
            break;


            default:
                    disabled = true; 
                    break; 

              }
            }




            /* si els dos terminis no estan activats mostrem altres condicions de pagament. normalment 0 */
          if(!config.dosTerminisEnabled) { props.curs.condicions = config.dosTerminisEnabledFalseCondicio } 

          return (
            <>
          <tr>
            <td>
            <input type="checkbox" id={m.id} name={m.id} value={m.preu} checked={isMaterialChecked(m.id)} disabled={disabled} onChange={(e) => handleChangeMaterial(e.target.id)} />
            <label for={m.id}>{m.txt}</label>
            </td>
            <td>
            {m.preu.toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
          </td></tr>

            {/* isMaterialChecked(m.id) && m.info !== undefined ?*/}
              { props.curs.id === "ESOLOE01" && 
              (<>
                    <tr>
                      <td>
                        <div style={{ maxWidth: '700px', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                           <h3>REUNIÓ INFORMATIVA ALUMNAT DE 1r d’ESO</h3>

                            Us informem que la reunió d'inici de curs tindrà lloc el dia 8 de setembre a les 18.00 h de la tarda.  
                          </div>
                      </td>
                    </tr>
                    </>)}


              {/* isMaterialChecked(m.id) && m.info !== undefined ?*/}
              { m.info !== undefined ?
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }} dangerouslySetInnerHTML={{ __html: m.info }} />
                      </td>
                      <td>
                      </td>
                    </tr>)
                    : null
                }

          </>
          )}
          )}

          <tr><th className="quotaNomCamp" colSpan="2"> Total a abonar a compte:</th></tr>

          <tr>

          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?
          (<>
           <td>Total: 
           { 
           exemptPagament(props.iddocument,props.becat) ? 
           ( <small>&nbsp;<i>Exempt de pagament de matrícula i llibres</i></small>)
           : exemptPagamentAmbLlibres(props.iddocument,props.becat) && ( <small>&nbsp;<i>Exempt del pagament de la matrícula (material i sortides) si que s'hauran de comprar els llibres.</i></small>)}
           
            </td>
          </>)
          :
          (<>
          { quota.menor28 ? (<td>Alumnat menor de 28 anys</td>) : (<td>Alumnat de 28 anys i major: </td>)}
          </>) 
          }

           <td className="quotaTotal"> {(quota.total).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>

          </tr>



          <tr>
          { !quota.menor28 && (<td colSpan={2}>

            <small><i>(Els alumnes més grans de 28 anys que disposin de la targeta sanitària del Servei Català de la Salut tenen coberta l'assistència sanitària, però no tenen dret a les prestacions que dona l'assegurança escolar obligatòria.)</i></small>

          </td>)}

          </tr>


          { mostraBotoTerminisCriteri  &&
          (<tr>
            <td colspan="2">
            <input type="checkbox" id="dosTerminis" name="dosTerminis" value={true} defaultChecked={props.dosTerminis} onChange={(e) => props.setDosTerminis(e.target.checked)} />
            <label for="dosTerminis">Vull fer el pagament en 2 terminis</label>
            </td>
          </tr>)
          }

           { props.dosTerminis && ( quota.termini1 !== undefined && quota.termini2 !== undefined ) && (
              <React.Fragment>
              <tr>
                <td>
                  Pagament 1r termini:  <small><i>{ text1Termini }</i></small>
                </td>
                <td>
                  { quota.termini1 && (quota.termini1).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              <tr>
                <td>
                  Pagament 2n termini:  <small><i>{ text2Termini }</i></small>
                </td>
                <td>
                  { quota.termini2 && (quota.termini2).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>

                { quota.termini3 !== undefined && (
                    <tr>
                      <td>
                        Pagament 3r termini:   <small><i>{ text3Termini }</i></small>
                      </td>
                      <td>
                        { (quota.termini3).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                      </td>
                    </tr>
                  )}

              </React.Fragment>
            )}


          </tbody>
        </table>

      </div>
      </div>

    </div >
  )
  
 }
